import { BadgeV3, ColorOption } from '@cimplico/components';
import { UserRoleEnum } from '../../../types/user';
import { formatMixedCase } from '../../../utilities/formatting';

function getRoleBadgeColour(role?: UserRoleEnum): ColorOption {
    switch (role) {
        case UserRoleEnum.USER:
            return 'blue';
        case UserRoleEnum.MANAGER:
            return 'red';
        case UserRoleEnum.ADMIN:
            return 'yellow';
        case UserRoleEnum.EXTERNAL_USER:
            return 'gray';
        default:
            return 'indigo';
    }
}

type UserRoleBadgeProps = {
    role?: UserRoleEnum;
};

function UserRoleBadge({ role }: UserRoleBadgeProps): JSX.Element {
    return (
        <div>
            <BadgeV3 size="small" color={getRoleBadgeColour(role)} label={formatMixedCase(role)} />
        </div>
    );
}

export default UserRoleBadge;
